
(function ( $ ) {
    "use strict";

    $.fn.uiSortableList = function( options ) {

        let config	= {
            isInitializedClassName: 'ui-sortable-list-initialized'
        };

        // have default options.
        let settings = $.extend({
            itemSelector:	".ui-sortable-list-item",
            onEvents:	'change',
            dataTargetAttr : 'data-ui-sortable-target',
            sortSeparator: ':'
        }, options );

        let uiSortItems = function(selector, sortValue) {

            if (typeof sortValue == 'undefined' || !sortValue) {
                return;
            }

            let sortBy = sortValue.split(settings.sortSeparator);
            let sortAttr = sortBy[0].toString();
            let sortDir = sortBy.length > 1 ? sortBy[1].toString() : 'asc';

            $(selector).children(settings.itemSelector).sort(function(a, b) {

                let sortable = 'data-ui-sortable-' + sortAttr;
                let itemA = $(a).attr(sortable).toUpperCase();
                let itemB = $(b).attr(sortable).toUpperCase();

                if (sortDir.toUpperCase()==='DESC') {
                    itemA = $(b).attr(sortable).toUpperCase();
                    itemB = $(a).attr(sortable).toUpperCase();
                }

                return (itemA < itemB) ? -1 : (itemA > itemB) ? 1 : 0;
            }).appendTo(selector);
        }

        this.each( function() {

            let elem = $( this );

            // if initialized run triggered event
            if (typeof elem != 'undefined' && elem.hasClass(config.isInitializedClassName+'-events')) {
                let targetListSelector = elem.attr(settings.dataTargetAttr);
                uiSortItems(targetListSelector, elem.val());
            }

            // bind events
            if( !elem.hasClass(config.isInitializedClassName+'-events') ) {
                elem.on(settings.onEvents, function(e) {
                    elem.uiSortableList( settings );
                }).addClass(config.isInitializedClassName+'-events');
            }
        });

        return this;
    };

    function pageLoaded()  {
        $('select.ui-sortable-list-listener').uiSortableList({onEvents: 'change'});
    }

    // add livewire navigated listener
    document.addEventListener('livewire:navigated', function () {
        pageLoaded();
    });

    // livewire is not installed
    if (typeof Livewire === "undefined") {
        // do jquery basic stuff after page has loaded
        $(function(){
            pageLoaded();
        });
    }

}(jQuery));
